/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getInspector = /* GraphQL */ `
  query GetInspector($id: ID!) {
    getInspector(id: $id) {
      id
      name
      homeAddress
      city
      state
      phoneNo
      email
      overAllRating
      inspectingSince
      registrationDate
      picture {
        bucket
        region
        key
      }
      accountStatus
      qualifications {
        title
        dateAchieved
        attachment {
          bucket
          region
          key
        }
      }
      skills
      experienceInYears
      employmentHistory {
        jobTitle
        company
        location {
          city
          state
        }
        startDate
        endDate
        currentlyWorking
        description
      }
      customers {
        items {
          id
          inspectorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      authorizedVehTypes
      userReviews {
        id
        reviewedby
        rating
        reviewTitle
        reviewDetails
        otherDetails
        reviewDate
      }
      remarks
      createdAt
      updatedAt
    }
  }
`;
export const listInspectors = /* GraphQL */ `
  query ListInspectors(
    $filter: ModelInspectorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInspectors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        homeAddress
        city
        state
        phoneNo
        email
        overAllRating
        inspectingSince
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        qualifications {
          title
          dateAchieved
        }
        skills
        experienceInYears
        employmentHistory {
          jobTitle
          company
          startDate
          endDate
          currentlyWorking
          description
        }
        customers {
          nextToken
        }
        authorizedVehTypes
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        remarks
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInspection = /* GraphQL */ `
  query GetInspection($id: ID!) {
    getInspection(id: $id) {
      id
      customerId
      vehicleId
      dvirVehicleInCombination
      inspectorUserType
      inspectorUserId
      vehicle {
        id
        customerVehicleId
        inspections {
          nextToken
        }
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
          createdAt
          updatedAt
        }
        specialInstructions
        mainPic {
          bucket
          region
          key
        }
        vinPic {
          bucket
          region
          key
        }
        licensePic {
          bucket
          region
          key
        }
        vehicleUploads {
          bucket
          region
          key
        }
        oilService {
          oilServiceType
          intervalValue
          currentMileage
          currentMileageLastUpdated
          lastTimeOilChangedAt
        }
        filters {
          filterCategory
          filterNumber
          notes
        }
        specialParts {
          partName
          partNumber
        }
        vehicleStatus
        defects {
          nextToken
        }
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      inspectionType
      inspectionStatus
      startAt
      endAt
      nextInspectionDue
      inspectionObservations
      inspectionForm {
        bucket
        region
        key
      }
      inspectionUploads {
        bucket
        region
        key
      }
      inspectionReport {
        bucket
        region
        key
      }
      federalStickerUpdated
      notes
      createdAt
      updatedAt
    }
  }
`;
export const listInspections = /* GraphQL */ `
  query ListInspections(
    $filter: ModelInspectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInspections(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerId
        vehicleId
        dvirVehicleInCombination
        inspectorUserType
        inspectorUserId
        vehicle {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        inspectionType
        inspectionStatus
        startAt
        endAt
        nextInspectionDue
        inspectionObservations
        inspectionForm {
          bucket
          region
          key
        }
        inspectionUploads {
          bucket
          region
          key
        }
        inspectionReport {
          bucket
          region
          key
        }
        federalStickerUpdated
        notes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDefect = /* GraphQL */ `
  query GetDefect($id: ID!) {
    getDefect(id: $id) {
      id
      customerId
      vehicleId
      vehicle {
        id
        customerVehicleId
        inspections {
          nextToken
        }
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
          createdAt
          updatedAt
        }
        specialInstructions
        mainPic {
          bucket
          region
          key
        }
        vinPic {
          bucket
          region
          key
        }
        licensePic {
          bucket
          region
          key
        }
        vehicleUploads {
          bucket
          region
          key
        }
        oilService {
          oilServiceType
          intervalValue
          currentMileage
          currentMileageLastUpdated
          lastTimeOilChangedAt
        }
        filters {
          filterCategory
          filterNumber
          notes
        }
        specialParts {
          partName
          partNumber
        }
        vehicleStatus
        defects {
          nextToken
        }
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      defectType
      defectDesc
      redTag
      priority
      status
      reportedByUserType
      reportedByUserId
      reportedDateTime
      sourceType
      sourceId
      assignedToUserType
      assignedToUserId
      assignedAtDateTime
      assignedByUserId
      assignmentNote
      isAccepted
      assignmentHistory {
        assignedToUserId
        assignedToUserType
        assignedAtDateTime
        assignmentNote
        refusedAtDateTime
        refusalNote
        assignedByUserId
      }
      repairedByUserType
      repairedByUserId
      repairedDateTime
      repairNotes
      partsUsedInRepair
      defectUploads {
        bucket
        region
        key
      }
      notes {
        items {
          id
          noteText
          noteType
          defectID
          addedByUserId
          addedByUserGroup
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listDefects = /* GraphQL */ `
  query ListDefects(
    $filter: ModelDefectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDefects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerId
        vehicleId
        vehicle {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        defectType
        defectDesc
        redTag
        priority
        status
        reportedByUserType
        reportedByUserId
        reportedDateTime
        sourceType
        sourceId
        assignedToUserType
        assignedToUserId
        assignedAtDateTime
        assignedByUserId
        assignmentNote
        isAccepted
        assignmentHistory {
          assignedToUserId
          assignedToUserType
          assignedAtDateTime
          assignmentNote
          refusedAtDateTime
          refusalNote
          assignedByUserId
        }
        repairedByUserType
        repairedByUserId
        repairedDateTime
        repairNotes
        partsUsedInRepair
        defectUploads {
          bucket
          region
          key
        }
        notes {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDefectNote = /* GraphQL */ `
  query GetDefectNote($id: ID!) {
    getDefectNote(id: $id) {
      id
      noteText
      noteAttachment {
        bucket
        region
        key
      }
      noteType
      defectID
      addedByUserId
      addedByUserGroup
      createdAt
      updatedAt
    }
  }
`;
export const listDefectNotes = /* GraphQL */ `
  query ListDefectNotes(
    $filter: ModelDefectNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDefectNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        noteText
        noteAttachment {
          bucket
          region
          key
        }
        noteType
        defectID
        addedByUserId
        addedByUserGroup
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVehicle = /* GraphQL */ `
  query GetVehicle($id: ID!) {
    getVehicle(id: $id) {
      id
      customerVehicleId
      inspections {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      make
      model
      VIN
      vehicleYear
      license
      locationLat
      locationLong
      nextInspectionDue {
        inspectionType
        nextDueDate
      }
      notes
      deactivateBIT
      deactivateDOT
      currentMileage
      currentMileageLastUpdated
      vehicleType {
        id
        vehicleType
        vehicleCategory
        observations
        createdAt
        updatedAt
      }
      specialInstructions
      mainPic {
        bucket
        region
        key
      }
      vinPic {
        bucket
        region
        key
      }
      licensePic {
        bucket
        region
        key
      }
      vehicleUploads {
        bucket
        region
        key
      }
      oilService {
        oilServiceType
        intervalValue
        currentMileage
        currentMileageLastUpdated
        lastTimeOilChangedAt
      }
      filters {
        filterCategory
        filterNumber
        filterImage {
          bucket
          region
          key
        }
        notes
      }
      specialParts {
        partName
        partNumber
        partImage {
          bucket
          region
          key
        }
      }
      vehicleStatus
      defects {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      defectsByStatus {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      inspectionsByDueDate {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listVehicles = /* GraphQL */ `
  query ListVehicles(
    $filter: ModelVehicleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVehicles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerVehicleId
        inspections {
          nextToken
        }
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
          createdAt
          updatedAt
        }
        specialInstructions
        mainPic {
          bucket
          region
          key
        }
        vinPic {
          bucket
          region
          key
        }
        licensePic {
          bucket
          region
          key
        }
        vehicleUploads {
          bucket
          region
          key
        }
        oilService {
          oilServiceType
          intervalValue
          currentMileage
          currentMileageLastUpdated
          lastTimeOilChangedAt
        }
        filters {
          filterCategory
          filterNumber
          notes
        }
        specialParts {
          partName
          partNumber
        }
        vehicleStatus
        defects {
          nextToken
        }
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVehicleType = /* GraphQL */ `
  query GetVehicleType($id: ID!) {
    getVehicleType(id: $id) {
      id
      vehicleType
      vehicleCategory
      observations
      createdAt
      updatedAt
    }
  }
`;
export const listVehicleTypes = /* GraphQL */ `
  query ListVehicleTypes(
    $filter: ModelVehicleTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVehicleTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        vehicleType
        vehicleCategory
        observations
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      calbitCustomerID
      companyName
      customerFirstName
      customerLastName
      customerAddresses {
        phoneNo
        faxNo
        address
        city
        state
        zipCode
        addressType
        locationLat
        locationLong
      }
      email
      registrationDate
      picture {
        bucket
        region
        key
      }
      accountStatus
      customerOverAllRating
      vehicles {
        items {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        nextToken
      }
      customerTeam {
        items {
          id
          empType
          empName
          phoneNo
          email
          accountStatus
          registrationDate
          notes
          username
          createdAt
          updatedAt
        }
        nextToken
      }
      userReviews {
        id
        reviewedby
        rating
        reviewTitle
        reviewDetails
        otherDetails
        reviewDate
      }
      generalInstructions
      inspectors {
        items {
          id
          inspectorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      vendors {
        items {
          id
          vendorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          offerAcceptedByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      registeredInspectionType
      defectsByStatus {
        items {
          id
          customerId
          vehicleId
          defectType
          defectDesc
          redTag
          priority
          status
          reportedByUserType
          reportedByUserId
          reportedDateTime
          sourceType
          sourceId
          assignedToUserType
          assignedToUserId
          assignedAtDateTime
          assignedByUserId
          assignmentNote
          isAccepted
          repairedByUserType
          repairedByUserId
          repairedDateTime
          repairNotes
          partsUsedInRepair
          createdAt
          updatedAt
        }
        nextToken
      }
      inspectionsByDueDate {
        items {
          id
          customerId
          vehicleId
          dvirVehicleInCombination
          inspectorUserType
          inspectorUserId
          inspectionType
          inspectionStatus
          startAt
          endAt
          nextInspectionDue
          inspectionObservations
          federalStickerUpdated
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomerTeam = /* GraphQL */ `
  query GetCustomerTeam($id: ID!) {
    getCustomerTeam(id: $id) {
      id
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        customerAddresses {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        email
        registrationDate
        picture {
          bucket
          region
          key
        }
        accountStatus
        customerOverAllRating
        vehicles {
          nextToken
        }
        customerTeam {
          nextToken
        }
        userReviews {
          id
          reviewedby
          rating
          reviewTitle
          reviewDetails
          otherDetails
          reviewDate
        }
        generalInstructions
        inspectors {
          nextToken
        }
        vendors {
          nextToken
        }
        registeredInspectionType
        defectsByStatus {
          nextToken
        }
        inspectionsByDueDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      empType
      empName
      picture {
        bucket
        region
        key
      }
      phoneNo
      email
      accountStatus
      registrationDate
      notes
      username
      createdAt
      updatedAt
    }
  }
`;
export const listCustomerTeams = /* GraphQL */ `
  query ListCustomerTeams(
    $filter: ModelCustomerTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customer {
          id
          calbitCustomerID
          companyName
          customerFirstName
          customerLastName
          email
          registrationDate
          accountStatus
          customerOverAllRating
          generalInstructions
          registeredInspectionType
          createdAt
          updatedAt
        }
        empType
        empName
        picture {
          bucket
          region
          key
        }
        phoneNo
        email
        accountStatus
        registrationDate
        notes
        username
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVendor = /* GraphQL */ `
  query GetVendor($id: ID!) {
    getVendor(id: $id) {
      id
      vendorType
      companyName
      firstName
      lastName
      phoneNo
      email
      address {
        phoneNo
        faxNo
        address
        city
        state
        zipCode
        addressType
        locationLat
        locationLong
      }
      accountStatus
      picture {
        bucket
        region
        key
      }
      vendorTeam {
        items {
          id
          empType
          firstName
          lastName
          phoneNo
          email
          accountStatus
          notes
          createdAt
          updatedAt
        }
        nextToken
      }
      customers {
        items {
          id
          vendorID
          customerID
          offerMadeAt
          offerNote
          offerStatus
          offerAcceptedAt
          offerRejectionNote
          offerMadeByUserId
          offerAcceptedByUserId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes
      createdAt
      updatedAt
    }
  }
`;
export const listVendors = /* GraphQL */ `
  query ListVendors(
    $filter: ModelVendorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        vendorType
        companyName
        firstName
        lastName
        phoneNo
        email
        address {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        accountStatus
        picture {
          bucket
          region
          key
        }
        vendorTeam {
          nextToken
        }
        customers {
          nextToken
        }
        notes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getVendorTeam = /* GraphQL */ `
  query GetVendorTeam($id: ID!) {
    getVendorTeam(id: $id) {
      id
      vendor {
        id
        vendorType
        companyName
        firstName
        lastName
        phoneNo
        email
        address {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        accountStatus
        picture {
          bucket
          region
          key
        }
        vendorTeam {
          nextToken
        }
        customers {
          nextToken
        }
        notes
        createdAt
        updatedAt
      }
      empType
      firstName
      lastName
      phoneNo
      email
      accountStatus
      notes
      picture {
        bucket
        region
        key
      }
      createdAt
      updatedAt
    }
  }
`;
export const listVendorTeams = /* GraphQL */ `
  query ListVendorTeams(
    $filter: ModelVendorTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVendorTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        vendor {
          id
          vendorType
          companyName
          firstName
          lastName
          phoneNo
          email
          accountStatus
          notes
          createdAt
          updatedAt
        }
        empType
        firstName
        lastName
        phoneNo
        email
        accountStatus
        notes
        picture {
          bucket
          region
          key
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFastCustomer = /* GraphQL */ `
  query GetFastCustomer($id: ID!) {
    getFastCustomer(id: $id) {
      id
      carrierName
      DOTNumber
      carrierAddress
      members {
        items {
          id
          customerId
          memberName
          phone
          email
          groupsAssigned
          createdAt
          updatedAt
        }
        nextToken
      }
      terminals {
        items {
          id
          customerId
          terminalName
          terminalAddress
          isDefault
          isDeactivated
          createdAt
          updatedAt
        }
        nextToken
      }
      vehicles {
        items {
          id
          vehicleId
          customerId
          terminalId
          isOutOfService
          isDeactivated
          type
          year
          make
          model
          nextDueDate
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listFastCustomers = /* GraphQL */ `
  query ListFastCustomers(
    $filter: ModelFastCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFastCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFastMember = /* GraphQL */ `
  query GetFastMember($id: ID!) {
    getFastMember(id: $id) {
      id
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      memberName
      phone
      email
      groupsAssigned
      createdAt
      updatedAt
    }
  }
`;
export const listFastMembers = /* GraphQL */ `
  query ListFastMembers(
    $filter: ModelFastMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFastMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerId
        customer {
          id
          carrierName
          DOTNumber
          carrierAddress
          createdAt
          updatedAt
        }
        memberName
        phone
        email
        groupsAssigned
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFastTerminal = /* GraphQL */ `
  query GetFastTerminal($id: ID!) {
    getFastTerminal(id: $id) {
      id
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      terminalName
      terminalAddress
      terminalPhoto {
        bucket
        region
        key
      }
      isDefault
      vehicles {
        items {
          id
          vehicleId
          customerId
          terminalId
          isOutOfService
          isDeactivated
          type
          year
          make
          model
          nextDueDate
          createdAt
          updatedAt
        }
        nextToken
      }
      isDeactivated
      createdAt
      updatedAt
    }
  }
`;
export const listFastTerminals = /* GraphQL */ `
  query ListFastTerminals(
    $filter: ModelFastTerminalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFastTerminals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerId
        customer {
          id
          carrierName
          DOTNumber
          carrierAddress
          createdAt
          updatedAt
        }
        terminalName
        terminalAddress
        terminalPhoto {
          bucket
          region
          key
        }
        isDefault
        vehicles {
          nextToken
        }
        isDeactivated
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFastVehicle = /* GraphQL */ `
  query GetFastVehicle($id: ID!) {
    getFastVehicle(id: $id) {
      id
      vehicleId
      customerId
      customer {
        id
        carrierName
        DOTNumber
        carrierAddress
        members {
          nextToken
        }
        terminals {
          nextToken
        }
        vehicles {
          nextToken
        }
        createdAt
        updatedAt
      }
      terminalId
      isOutOfService
      isDeactivated
      type
      year
      make
      model
      photo {
        bucket
        region
        key
      }
      nextDueDate
      inspectionHistory {
        inspectionDate
        attachments {
          bucket
          region
          key
        }
        timeStamp
      }
      createdAt
      updatedAt
    }
  }
`;
export const listFastVehicles = /* GraphQL */ `
  query ListFastVehicles(
    $filter: ModelFastVehicleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFastVehicles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        vehicleId
        customerId
        customer {
          id
          carrierName
          DOTNumber
          carrierAddress
          createdAt
          updatedAt
        }
        terminalId
        isOutOfService
        isDeactivated
        type
        year
        make
        model
        photo {
          bucket
          region
          key
        }
        nextDueDate
        inspectionHistory {
          inspectionDate
          timeStamp
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const itemsByDueDate = /* GraphQL */ `
  query ItemsByDueDate(
    $customerId: ID
    $nextInspectionDue: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInspectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByDueDate(
      customerId: $customerId
      nextInspectionDue: $nextInspectionDue
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        vehicleId
        dvirVehicleInCombination
        inspectorUserType
        inspectorUserId
        vehicle {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        inspectionType
        inspectionStatus
        startAt
        endAt
        nextInspectionDue
        inspectionObservations
        inspectionForm {
          bucket
          region
          key
        }
        inspectionUploads {
          bucket
          region
          key
        }
        inspectionReport {
          bucket
          region
          key
        }
        federalStickerUpdated
        notes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const byVehicleDueDate = /* GraphQL */ `
  query ByVehicleDueDate(
    $vehicleId: ID
    $nextInspectionDue: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInspectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byVehicleDueDate(
      vehicleId: $vehicleId
      nextInspectionDue: $nextInspectionDue
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        vehicleId
        dvirVehicleInCombination
        inspectorUserType
        inspectorUserId
        vehicle {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        inspectionType
        inspectionStatus
        startAt
        endAt
        nextInspectionDue
        inspectionObservations
        inspectionForm {
          bucket
          region
          key
        }
        inspectionUploads {
          bucket
          region
          key
        }
        inspectionReport {
          bucket
          region
          key
        }
        federalStickerUpdated
        notes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const itemsByStatus = /* GraphQL */ `
  query ItemsByStatus(
    $customerId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDefectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByStatus(
      customerId: $customerId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        vehicleId
        vehicle {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        defectType
        defectDesc
        redTag
        priority
        status
        reportedByUserType
        reportedByUserId
        reportedDateTime
        sourceType
        sourceId
        assignedToUserType
        assignedToUserId
        assignedAtDateTime
        assignedByUserId
        assignmentNote
        isAccepted
        assignmentHistory {
          assignedToUserId
          assignedToUserType
          assignedAtDateTime
          assignmentNote
          refusedAtDateTime
          refusalNote
          assignedByUserId
        }
        repairedByUserType
        repairedByUserId
        repairedDateTime
        repairNotes
        partsUsedInRepair
        defectUploads {
          bucket
          region
          key
        }
        notes {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const byVehicleIdStatus = /* GraphQL */ `
  query ByVehicleIdStatus(
    $vehicleId: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDefectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byVehicleIdStatus(
      vehicleId: $vehicleId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        vehicleId
        vehicle {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        defectType
        defectDesc
        redTag
        priority
        status
        reportedByUserType
        reportedByUserId
        reportedDateTime
        sourceType
        sourceId
        assignedToUserType
        assignedToUserId
        assignedAtDateTime
        assignedByUserId
        assignmentNote
        isAccepted
        assignmentHistory {
          assignedToUserId
          assignedToUserType
          assignedAtDateTime
          assignmentNote
          refusedAtDateTime
          refusalNote
          assignedByUserId
        }
        repairedByUserType
        repairedByUserId
        repairedDateTime
        repairNotes
        partsUsedInRepair
        defectUploads {
          bucket
          region
          key
        }
        notes {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const byVehicleIdInspectionId = /* GraphQL */ `
  query ByVehicleIdInspectionId(
    $vehicleId: ID
    $sourceId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDefectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byVehicleIdInspectionId(
      vehicleId: $vehicleId
      sourceId: $sourceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        vehicleId
        vehicle {
          id
          customerVehicleId
          make
          model
          VIN
          vehicleYear
          license
          locationLat
          locationLong
          notes
          deactivateBIT
          deactivateDOT
          currentMileage
          currentMileageLastUpdated
          specialInstructions
          vehicleStatus
          createdAt
          updatedAt
        }
        defectType
        defectDesc
        redTag
        priority
        status
        reportedByUserType
        reportedByUserId
        reportedDateTime
        sourceType
        sourceId
        assignedToUserType
        assignedToUserId
        assignedAtDateTime
        assignedByUserId
        assignmentNote
        isAccepted
        assignmentHistory {
          assignedToUserId
          assignedToUserType
          assignedAtDateTime
          assignmentNote
          refusedAtDateTime
          refusalNote
          assignedByUserId
        }
        repairedByUserType
        repairedByUserId
        repairedDateTime
        repairNotes
        partsUsedInRepair
        defectUploads {
          bucket
          region
          key
        }
        notes {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const notesByDefectId = /* GraphQL */ `
  query NotesByDefectId(
    $defectID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelDefectNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notesByDefectId(
      defectID: $defectID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        noteText
        noteAttachment {
          bucket
          region
          key
        }
        noteType
        defectID
        addedByUserId
        addedByUserGroup
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries.js